import styled from 'styled-components';

export const DropdownWrapper = styled.div`
    position: relative;
    &::after {
        content: '';
        position: absolute;
        top: calc(50% - 4px);
        right: 16px;
        width: 12px;
        height: 12px;
        border-style: solid;
        border-width: 0 1px 1px 0;
        pointer-events: none;
        transform: translateY(-50%) rotate(45deg);
    }
`;

export const DropdownSelect = styled.select`
    margin: 0;
    cursor: pointer;
    width: fit-content;
    vertical-align: top;
    border-radius: 4px;
    border-width: 2px;
    display: inline-block;
    padding: 12px 50px 12px 20px;
`;

export const DropdownOption = styled.option`
    cursor: pointer;
    padding: 1px 5px;
`;
